import { render, staticRenderFns } from "./TraitComparisonSelection.vue?vue&type=template&id=0d5657aa&scoped=true&"
import script from "./TraitComparisonSelection.vue?vue&type=script&lang=js&"
export * from "./TraitComparisonSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5657aa",
  null
  
)

export default component.exports